import React from 'react';
import DoctorsCard from '../DoctorsCard/DoctorsCard';

const Doctors = () => {
    return (
        <div className='container mt-5 pt-5'>
            <h4 className='text-center head-color fw-bold'>Our Doctors</h4>
            <div className="row mt-5 pt-5" >
                <DoctorsCard></DoctorsCard>
                <DoctorsCard></DoctorsCard>
                <DoctorsCard></DoctorsCard>
            </div>
            
        </div>
    );
};

export default Doctors;